export interface BulkEditRowsResult {
  failedCount: number
  succeededCount: number
}

export async function bulkEditRows<TRowId>(
  rowIds: TRowId[],
  editRow: (rowId: TRowId) => Promise<unknown>
): Promise<BulkEditRowsResult> {
  const results = await Promise.allSettled(
    rowIds.map((rowId) => editRow(rowId))
  )
  const failedCount = results.filter(
    (result) => result.status === 'rejected'
  ).length

  return {
    failedCount,
    succeededCount: results.length - failedCount,
  }
}
